import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { share, switchMap, takeUntil } from "rxjs/operators";
import {Subject } from "rxjs";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";
import { ShipmentModel } from "src/app/models/shipment.model";
import {
  LocationHistoryReasonTypeAhead,
  WareHouseDropdownList,
  WarehouseLocationsSummery,
} from "src/app/models/warehouse.model";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { ShipmentSku } from "src/app/models/shipyard.model";
import { GridApi } from "@ag-grid-community/core";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";

import { LogisticService } from "../../logistic.service";
import { MatAutocomplete } from "@angular/material/autocomplete";
import { HeaderService } from "src/app/components/header/header.service";
@Component({
  selector: "app-popup-location-summery",
  templateUrl: "./popup-location-summery.component.html",
  styleUrls: ["./popup-location-summery.component.scss"],
})
export class PopupLocationSummeryComponent implements OnInit,OnDestroy,AfterViewInit {             
  public isProductdisable: boolean=false;
  whLocationForm: FormGroup = new FormGroup({
    autocomplete: new FormControl(null,Validators.required),
    warehouseId: new FormControl(0,Validators.required),
    locationCode: new FormControl("",Validators.required),
    qty: new FormControl({value: '', disabled: this.dialogData.locationSummaryId},Validators.required),
    action: new FormControl(''),
  });
  @ViewChild('auto') public scroll!: MatAutocomplete;

  whs: WareHouseDropdownList[] = [];
  warehouseId: number;
  shipment: ShipmentModel;
  private destroy$ = new Subject<void>();
  public locationSummaryId: number = 0;
  locationId: number = 0;
  vendorOptions: LocationHistoryReasonTypeAhead[];
  gridApi: GridApi;
  //**  */
  filteredOptions$: any;
  startRow = 0;
  amountPerPage = 10;
  startRowArray:any[]=[];
  getLocationId: any;
  spin: boolean=false;
  //**- */ */
  @ViewChild('qtyInput') qtyInput: ElementRef;
  locations:any[]=[];
  updateQty: FormControl = new FormControl();
  updateQtyValue: any;
  isAdditionSign = new FormControl(true);
  isPlanYard;
  hasNoWhs:boolean=false;

  constructor(
    private logisticsService: LogisticService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<PopupLocationSummeryComponent>,
    private planyardService: PlanyardService,
    public headerService:HeaderService,
    @Inject(MAT_DIALOG_DATA) public dialogData
  ) {}

  ngOnInit(): void {
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginModel) => {
        this.isPlanYard= res.isPlanYard;
        this.whLocationForm.patchValue({ submittedBy: res.username });
      });

   this.whLocationForm
      .get("autocomplete")
      .valueChanges.pipe(
        takeUntil(this.destroy$),
        switchMap((value) =>{
          if(value){
            this.startRow=0;
            const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
            if(idx != -1){
              this.startRowArray['startrow_']=0
            }else{
              this.startRowArray['startrow_'] = 0;  
            }
            return this.planyardService.TypeaheadItem(value ? value : "", 0, "Item",this.startRow,this.startRow + this.amountPerPage)
          } else{
            let e = [];
            return e;
          }
        }
        ),
        share()
      ).subscribe((e)=>{
        this.filteredOptions$ = e;
        this.startRowArray['startrow_']+= this.amountPerPage;
      });
      if(!this.dialogData.locationid){
        this.whLocationForm.get("warehouseId")
        .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
          if(res){
            this.logisticsService.GetLocationByWId(res).pipe(takeUntil(this.destroy$)).subscribe((data:any[])=>{
              if(data){
               this.locations=data;
               this.whLocationForm.get('locationCode').setValue(this.locations[0]);
              }
          })
          }
          else{
            this.whLocationForm.controls['warehouseId'].setErrors({'incorrect': true});
          }
        })
      }

    this.GetWareHouseList();

    if (this.dialogData) {
      if (this.dialogData.locationSummaryId > 0) {
        this.locationSummaryId = this.dialogData.locationSummaryId;
        this.whLocationForm.get('action').setValidators(Validators.required);
       }
      if (this.dialogData.isProductdisable === 1) {
        this.isProductdisable = true;
      }
      this.locations=[
        {
          locationId:this.dialogData.locationid,
          locationCode:this.dialogData.LocationCode
        }
      ]

      this.whLocationForm.patchValue({
        warehouseId: this.dialogData.WarehouseId,
        locationCode: this.locations[0],
        qty: (this.dialogData.qty || this.dialogData.qty == 0) ? this.dialogData.qty : 1,
        autocomplete: this.dialogData?.itemId ? {
          id: this.dialogData?.itemId,
          title: this.dialogData?.itemName,
        } : null,
        action:this.dialogData.action
      });
    } else {
      this.whLocationForm.patchValue({
        warehouseId: 0,
      });
    }
  }

  ngAfterViewInit() {
    if(this.dialogData.qty){
      setTimeout(() => {
        this.qtyInput.nativeElement.focus();
      },200);
    }
  }

  displayWith(value: ShipmentSku) {
    if (value) {
      return value.title;
    }
  }

  GetWareHouseList() {
    this.logisticsService
      .GetAllWareHouseList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: WareHouseDropdownList[]) => {
        if (response) {
          this.whs = response;
          if(!this.whs.length) this.hasNoWhs=true
          if(this.whs.length== 1 && !this.dialogData.WarehouseId){
            this.whLocationForm.controls['warehouseId'].setValue(this.whs[0].warehouseId);
          }
        }
      });
    if (this.whs == null) {
      this.whs = [];
    }
  }

  action(e): void {
    if (e === "Save" || e == "Update") {
      this.spin = true;
      this.save();
    } else {
      this.dialogRef.close();
    }
  }

  selectOption(option): void {
    this.whLocationForm.patchValue({ reasonId: option.reasonId });
  }

  displayFn(lhReason: LocationHistoryReasonTypeAhead): string {
    return lhReason?.reason ? lhReason.reason : "";
  }

  save(): void {
    const payload = this.whLocationForm.value as WarehouseLocationsSummery;
    payload.warehouseId = this.whLocationForm.controls.warehouseId.value;
    payload.locationCode = this.whLocationForm.controls.locationCode.value.locationCode;
    payload.locationId = this.whLocationForm.controls.locationCode.value.locationId
    payload.qty = this.updateQtyValue ? this.updateQtyValue : this.whLocationForm.controls.qty.value;
    payload.itemId = payload.autocomplete.id;
    if(this.whLocationForm.controls.action.value){
      payload.action= this.whLocationForm.controls.action.value;
    }else{
      payload.action= "Add new item to location";
    }
    if (payload.warehouseId != undefined && payload.warehouseId != null) {
      const obj = this.whs.filter(
        (x) => x.warehouseId == payload.warehouseId
        )
        payload.warehouseName = obj[0]?.name;
    }
    if (this.locationSummaryId > 0) {
      payload.locationSummaryId = this.locationSummaryId;
    }
    this.logisticsService.SaveLocationSummery(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res) => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: `Warehouse stock ` +
          (this.dialogData?.locationSummaryId ? "updated" : "added") +
          ` successfully`,
          action: 'Dismiss',
          type: 'info',
        },
      });
      this.spin=false;
      this.dialogRef.close({...payload});
    },
   error: (err) => {
      this.spin=false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err?.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  onChange(){
   if(this.updateQty.value != null){
    if(this.isAdditionSign.value) {
      this.updateQtyValue = this.dialogData.qty + this.updateQty.value;
    } else {
      this.updateQtyValue = this.dialogData.qty - this.updateQty.value;
    }
    this.whLocationForm.get("qty").setValue(this.updateQtyValue);
    } else{ 
      this.whLocationForm.get("qty").setValue(this.dialogData.qty);
    }
  }

 
  loadAllOnScroll(event) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) {     
      const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
      if(idx != -1){
        this.startRow=this.startRowArray['startrow_'];
      }else{
        this.startRowArray['startrow_'] = 0; 
        this.startRow=0;
      }
      this.startRowArray['startrow_']+= this.amountPerPage;
      const value= this.whLocationForm.get("autocomplete").value;
      this.planyardService.TypeaheadItem(value, null, 'Item',this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
       this.filteredOptions$.push(...res);
      });
    }
  }
  registerPanelScrollEvent(element) {
      const panel = element;
     panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
   }

  setScroll(){
    const element= document.getElementById(this.scroll.id);
      if(element){     
        this.registerPanelScrollEvent(element);
      }
    }
}
